import React, { Component } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
} from "@mui/material";

// Ícones MUI equivalentes para as vantagens gerais do lojista
import StorefrontIcon from "@mui/icons-material/Storefront";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";

class PorQue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vantagens: [
        {
          titulo: "Catálogo Online & Link Próprio",
          descricao:
            "Tenha sua própria vitrine virtual com link exclusivo para divulgar nas redes sociais e receber pedidos diretos, sem intermediários.",
          icone: <StorefrontIcon sx={{ color: "#7C3AED", fontSize: 22 }} />,
        },
        {
          titulo: "Mais Lucro e Zero Comissões",
          descricao:
            "Pare de perder margem com taxas abusivas por venda. No FazPedido o faturamento das suas vendas é 100% seu.",
          icone: <TrendingUpIcon sx={{ color: "#7C3AED", fontSize: 22 }} />,
        },
        {
          titulo: "Controle de Envios e Entregas",
          descricao:
            "Organize taxas de frete por região, emita etiquetas e acompanhe o status de cada pedido do pagamento até a entrega ao cliente.",
          icone: <LocalShippingIcon sx={{ color: "#7C3AED", fontSize: 22 }} />,
        },
        {
          titulo: "Caixa e PDV Integrado",
          descricao:
            "Sincronize o estoque da loja física com o e-commerce automaticamente, feche o caixa com segurança e emita relatórios financeiros completos.",
          icone: <PointOfSaleIcon sx={{ color: "#7C3AED", fontSize: 22 }} />,
        },
      ],
    };
  }

  render() {
    return (
      <Box
        component="section"
        id="por-que"
        sx={{
          bgcolor: "#F5F3FF",
          borderTop: "1px solid #E3E1F8",
          py: { xs: 6, sm: 10 },
        }}
      >
        <Container maxWidth="xl">
          {/* Cabeçalho da Seção */}
          <Box sx={{ mx: "auto", maxWidth: "700px", textAlign: "center", mb: 8 }}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontWeight: 800,
                color: "#1E1B4B",
                fontSize: { xs: "2rem", sm: "2.5rem", lg: "2.75rem" },
                mb: 2,
                lineHeight: 1.2,
              }}
            >
              Por que o FazPedido é a plataforma ideal para sua loja
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#464467",
                fontSize: { xs: "1rem", sm: "1.1rem" },
                lineHeight: 1.6,
              }}
            >
              Não é apenas um sistema de vendas, é a chave para você ter{" "}
              <strong>mais autonomia</strong>, aumentar sua rentabilidade e{" "}
              <strong>simplificar a gestão do seu comércio</strong> do balcão à entrega.
            </Typography>
          </Box>

          {/* Grade de Vantagens */}
          <Grid container spacing={3}>
            {this.state.vantagens.map((item, index) => (
              <Grid size={{ xs: 12, sm: 6, lg: 3 }} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    height: "100%",
                    borderRadius: "20px",
                    border: "1px solid #DAD7FE",
                    bgcolor: "#ffffff",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 12px 28px -8px rgba(124, 58, 237, 0.2)",
                      borderColor: "#7C3AED",
                    },
                  }}
                >
                  <CardContent sx={{ p: 3.5, display: "flex", flexDirection: "column", height: "100%" }}>
                    {/* Ícone de Destaque */}
                    <Box
                      sx={{
                        display: "flex",
                        h: 48,
                        w: 48,
                        minWidth: 48,
                        minHeight: 48,
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "14px",
                        bgcolor: "rgba(124, 58, 237, 0.1)",
                        mb: 3,
                      }}
                    >
                      {item.icone}
                    </Box>

                    {/* Título do Card */}
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        fontWeight: 700,
                        color: "#1E1B4B",
                        fontSize: "1.15rem",
                        mb: 1.5,
                      }}
                    >
                      {item.titulo}
                    </Typography>

                    {/* Descrição */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#464467",
                        fontSize: "0.95rem",
                        lineHeight: 1.6,
                        flexGrow: 1,
                      }}
                    >
                      {item.descricao}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    );
  }
}

export default PorQue;